module.exports = __webpack_public_path__ + "img/red_062.6de89862.png";